@if (submissionList | async; as approvalsList) {
  <ng-component
    *ngTemplateOutlet="
      approvalsList.length > 0 ? list : noRecordsFound;
      context: { submissionList: submissionList | async }
    "
    >
  </ng-component>
} @else {
  <loading-icon></loading-icon>
}

<ng-template #list let-approvalsList="submissionList">
  <div class="approval-list">
    @for (list of approvalsList; track list) {
      <div
        (click)="selectApproval(list)"
        class="approval-list-item"
        [ngClass]="{ 'approval-list-item-selected': list.id === localSelectedApproval }"
        >
        <img class="approval-list-flow-icon" src="../../../../../../assets/svg/flow-black.svg" />
        <div
          class="approval-list-flow-name"
        [innerHTML]="
          highlightIfSearchedFor(list.flowPath || 'Name Missing - Please resubmit to fix')
        "
        ></div>
        <div class="approval-list-flow-date">
          {{ list.cdcUpdateTimestamp | date: 'yyyy/MM/dd' }}<br />{{
          list.cdcUpdateTimestamp | date: 'HH:mm:ss'
          }}
        </div>
      </div>
    }
  </div>
</ng-template>

<ng-template #noRecordsFound>
  <div class="no-records-found">
    <div class="no-records-found-item">No Approvals Found</div>
  </div>
</ng-template>

